<template>
  <div class=" is-fullwidth">
    <div class="level">
        <div class="level-left">
          <div class="columns" >
            <div class="select col" >
                  <select v-model="location_id" class="input "  :disabled="loading==true">
                            <option value="">Select location ...</option>
                            <option value="1">Strabane</option>
                            <option value="4">Derry</option>
                        </select>
              </div> 
            <div class="select col" >
                <select v-model="user_id" :disabled="loading==true">
                  <option value="">Select User</option>
                  <option :value="row.userID" v-for="row in filteredUsers" :key="row.userID">{{ row.firstname }} {{ row.surname }}</option>
                  
                </select>
              </div> 
            
            <div class="ml-1 select col" v-if="1==2">
                <select v-model="area">
                  <option value="">All Operations</option>
                  <option value="received">Received</option>
                  <option value="on_factory_floor">On Factory Floor</option>
                  <option value="off_factory_floor">Off Factory Floor</option>
                  <option value="embroidery">Embroidery</option>
                  <option value="silicon_stripes">Silicon Stripes</option>
                  <option value="gps_pockets">GPS Pockets</option>
                  <option value="embossing">Embossing</option>
                </select>
              </div>

              <div class="ml-1 select col">
                <select class="input" v-model="range_id">
                <option value="">All Ranges</option>
                <option value="1">Jerseys</option>
                <option value="2">Leisurewear</option>
                <option value="3">Shorts</option>
                <option value="4">Accessories</option>
              </select>

              </div>
            

             <div class="ml-1 col">
                <input type="date" class="input" v-model="start_date" />
                
              </div>
              <div class="ml-1  col" >
                <input type="date" class="input" v-model="end_date" />
                
              </div>

              <div class="ml-1 col">
                  <table class="table is-hoverable is-bordered " id="overviewtable" >
                    <tbody>
                      <tr>
                        <td class="">Total {{ total_label }}</td>
                        <td>{{ total_qty }}</td>
                      
                        </tr>
                    </tbody>
                  </table>
                </div>
            </div>
      </div>
        
      </div>
      <div class="notification is-info" v-if="loading == true">Loading data ...</div>

    <table class="table is-hoverable is-fullwidth" id="entriestable" v-if="loading == false && entries.length > 0">
    	<thead>
    		<tr>
          <th>Date </th>
          <th>Operation</th>
          <th>User </th>
        <th>Qty</th>
        <th>Size</th>
        <th>Order</th>
        <th>Range</th>
       
   	 	    </tr>
    	</thead>
    	<tbody>
		    
        <tr v-for="row in entries" v-bind:key="row.id" >
          <td >{{ row.date }}</td>
          <td >{{ row.operation_label }}</td>
          <td >{{ row.firstname }} {{ row.surname }}</td>
          <td>{{row.qty}}</td>
          <td>{{row.size_name}}</td>
          <td>{{row.ponumber}}</td>
          <td>{{row.range}}</td>
              
			</tr>
    	</tbody>
    </table>
    


    <button @click="exportXLS()" class="button is-info" v-if="loading==false">Export to Excel</button>

     
    
  </div>
</template>

<script>

import OrderService from '@/services/OrderService.js';
import OrderMixin from "@/mixins/OrderMixin.js";
import XLSX from 'xlsx';

export default {
  name:'PrintingCuttingSummary',
  components: {
   	
  },
  mixins: [OrderMixin],
  data() {
    return {
     entries: [],
     area: '',
      start_date: this.getStartDate(),
        end_date: new Date().toISOString().slice(0,10),
      currentSort: 'count',
      currentSortDir: 'desc',
      loading: true,
     accessToken: '',
     
     makeuplocations: [],
     range_id:'',
     user_id: '',
     users: [],
     location_id: ''
     
     
    }
  },
  created() {
      this.getAccessToken()
        .then(() => { 
          this.getMakeupUsers();
          this.getMakeupLocations();
            this.getData()
        });
      
    },
  methods: {
    
    exportXLS() {
		 //alert("hi")
		 var wb = XLSX.utils.table_to_book(document.getElementById('entriestable'), {sheet:"Sheet 1"});
		 XLSX.writeFile(wb, 'Productivity Scanning Report.xlsx')

	 },
   
    async getData() {
      this.loading=true;
      OrderService.getProductivityReportData(this.accessToken, this.area, this.start_date, this.end_date, '', this.range_id, this.user_id, this.location_id)
          .then(
            (entries => {
              
              this.$set(this, "entries", entries);
              this.loading=false;
            }).bind(this)
          );
      
    },
   
    getStartDate() {
            
            var d = new Date();
            
            d.setDate(d.getDate() - 7);
            return d.toISOString().slice(0,10);
             
        },

        
   
  },
  computed : {
     
    
      total_qty: function() {
        return this.entries.reduce((total, item) => total + item.qty, 0);
      },
      total_label: function() {
          if(this.area == "savings")
          {
            return "Orders"
          }
          else{
            return "Garments"
          }
        },
        filteredUsers() {
          if (this.location_id && this.location_id !== 0) {
            return Object.fromEntries(
              Object.entries(this.users).filter(
                ([, user]) => user.user_location_id == this.location_id
              )
            );
          }
          else {
            return this.users;
          }
        }

  },
  
  mounted() {
    /*if (localStorage.makeup_summary_report_location_id) {
      this.location_id = localStorage.makeup_summary_report_location_id;
    }
    else{
      this.location_id = ''
    }

    if (localStorage.makeup_summary_report_area) {
      this.area = localStorage.makeup_summary_report_area;
    }
    else{
      this.area = ''
    }

    if (localStorage.makeup_summary_range_id) {
      this.range_id = localStorage.makeup_summary_range_id;
    }
    else{
      this.area = ''
    }*/

    if (localStorage.productivity_reporting_location_id) {
      this.location_id = localStorage.productivity_reporting_location_id;
    }
    else{
      this.location_id = ''
    }
  },
  watch: {
    
    start_date: function () {
      this.entries = []
      this.getData()
    },
    end_date: function () {
      this.entries = []
      this.getData()
    },
    /*location_id: function () {
      localStorage.makeup_summary_report_location_id = this.location_id
      if(this.accessToken != "")
      {
        this.entries = []
        this.getData()
      }
    },
    area: function () {
      localStorage.makeup_summary_report_area = this.area
      if(this.accessToken != "")
      {
        this.entries = []
        this.getData()
      }
    },
    */
    range_id: function () {
      //localStorage.makeup_summary_range_id = this.range_id
      if(this.accessToken != "")
      {
        this.entries = []
        this.getData()
      }
    },
    user_id: function () {
      //localStorage.makeup_summary_range_id = this.range_id
      if(this.accessToken != "")
      {
        this.entries = []
        this.getData()
      }
    },
    location_id: function() {
      localStorage.productivity_reporting_location_id = this.location_id
      if(this.accessToken != "")
      {
        this.entries = []
        this.getData()
      }
    },
  }
}



</script>


